import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    bonuses: 'bg-accent flex items-center gap-10 rounded-[100px] px-6 py-4',
    bonusesAfterOrder: 'flex items-center gap-[2px]',
    bonusesLabel: '',
    unitsLabel: 'ml-2 text-[12px] text-gray-500',
    bonusesButton: 'cursor-pointer font-bold',
    delivery: 'hidden lg:block',
    tooltip: 'heading-xs max-w-[184px]',
    infoIcon: 'text-blue-dark ml-1 inline-block h-5 w-5 cursor-pointer'
  }
});
